/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useReducer } from 'react';
import sitesData from '../data/data';
import GitService from '../services/gitlab';
import OpenMergeRequests from '../components/atoms/open-merge-requests';
import BranchDifference from '../components/atoms/branch-differences';
import { useParams } from 'react-router-dom';
import ConfigurationEnv from '../components/atoms/configuration-env';
import ClosedMergeRequests from '../components/atoms/closed-merge-requests';
import { getBranches } from '../helpers/common';



const initialVersions = {
  theme: {
    develop: '',
    master: '',
    prelive: '',
    'qa-automation': ''
  },
  core: {
    develop: '',
    master: '',
    prelive: '',
    'qa-automation': ''
  },
  latest: {
    theme: '',
    core: ''
  }
};

function versionsReducer(state, action) {
  switch (action.type) {
    case 'SET_THEME_VERSION':
      return {
        ...state,
        theme: {
          ...state.theme,
          [action.branch]: action.version
        }
      };
    case 'SET_CORE_VERSION':
      return {
        ...state,
        core: {
          ...state.core,
          [action.branch]: action.version
        }
      };
    case 'SET_LATEST_THEME_VERSION':
      return {
        ...state,
        latest: {
          ...state.latest,
          theme: action.version
        }
      };
    case 'SET_LATEST_CORE_VERSION':
      return {
        ...state,
        latest: {
          ...state.latest,
          core: action.version
        }
      };
    default:
      return state;
  }
}

function extractCoreThemeVersionFromLock(content) {
  const regex = /^gatsby-core-theme@([\w.-]+):/m;
  const match = content.match(regex);
  return match ? match[1] : '';
}

export default function Siteinfo() {
  const [site, setSite] = useState(null);
  const [theme, setTheme] = useState(null);
  const [versions, dispatch] = useReducer(versionsReducer, initialVersions);
  const params = useParams();

  const fetchThemeVersions = async (site, theme) => {
    await Promise.all(
      getBranches(site).map(async ({ branch }) => {
        try {
          // Get theme version from package.json
          const response = await GitService.getSiteThemePackage(site.id, branch);
          const themeDep = response?.data?.dependencies?.[`gatsby-${theme.name}-theme`];
          if (themeDep) {
            dispatch({
              type: 'SET_THEME_VERSION',
              branch,
              version: themeDep.replace('^', '')
            });
          }

          // Get core version from yarn.lock
          const lockResponse = await GitService.getSiteGatsbyCoreThemePackageFromLockFile(site.id, branch);
          const coreVersion = extractCoreThemeVersionFromLock(lockResponse.data);
          if (coreVersion) {
            dispatch({
              type: 'SET_CORE_VERSION',
              branch,
              version: coreVersion
            });
          }
        } catch (error) {
          console.error(`Failed to fetch data for branch ${branch}`, error);
        }
      })
    );
  };

  const fetchLatestVersions = async (theme) => {
    try {
      // Latest theme version
      const themeTags = await GitService.getTags(theme.id);
      if (themeTags.data.length > 0) {
        dispatch({
          type: 'SET_LATEST_THEME_VERSION',
          version: themeTags.data[0].name.replace('v', '')
        });
      }

      // Latest core version (gatsby-core-theme = 'gatsby' theme)
      const coreThemeId = sitesData().themes.find(t => t.name === 'gatsby')?.id;
      if (coreThemeId) {
        const coreTags = await GitService.getTags(coreThemeId);
        if (coreTags.data.length > 0) {
          dispatch({
            type: 'SET_LATEST_CORE_VERSION',
            version: coreTags.data[0].name.replace('v', '')
          });
        }
      }
    } catch (error) {
      console.error('Failed to fetch latest versions', error);
    }
  };

  const getSiteUrl = (type = null) => {
    return type ? `https://${type}.${site.name}` : `https://${site.name}`;
  };

  const tagUrl = (themeName, tagVersion) => {
    return `https://gitlab.com/g2m-gentoo/team-floyd/themes/${themeName}/-/tags/${tagVersion}`;
  };

  useEffect(() => {
    const resolveSite = async () => {
      let siteData = null;
      let themeData = null;

      sitesData().themes.forEach((themeItem) =>
        themeItem.sites.forEach((siteItem) => {
          if (siteItem.id == params.id) {
            siteData = siteItem;
            themeData = themeItem;
          }
        })
      );

      if (siteData && themeData) {
        setTheme(themeData);
        setSite(siteData);
        fetchThemeVersions(siteData, themeData);
        fetchLatestVersions(themeData);
      } else {
        params.history?.push?.('/');
      }
    };

    resolveSite();
  }, []);

  return site ? (
    <div className="container">
      <div className="row">
        <div className="col-lg-7 d-flex">
          <div className="card w-100">
            <div className="card-body">
              <div className="row">
                <div className="col">
                  <div className="d-flex flex-wrap gap-4">
                    <div className={`avatar avatar-lg bg-${theme.color}`}>
                      <img
                        style={{ maxWidth: '10rem' }}
                        src={site.logo}
                        alt={site.name}
                      />
                    </div>
                    <h1>{site.name}</h1>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12 d-flex flex-x2 flex-gutter-sm">
                  {site.repo && (
                    <span className="d-flex align-items-center gap-1">
                      <i className="uil uil-code-branch"></i>
                      <a target="_blank" href={site.repo} rel="noreferrer">
                        Git
                      </a>
                    </span>
                  )}

                  {site.release_notes && (
                    <span className="d-flex align-items-center gap-1">
                      <i className="uil uil-notes"></i>
                      <a
                        target="_blank"
                        href={site.release_notes}
                        rel="noreferrer"
                      >
                        Release Notes
                      </a>
                    </span>
                  )}

                  <span className="d-flex align-items-center gap-1">
                    <i className="uil uil-list-ui-alt"></i>
                    <a
                      target="_blank"
                      href="https://gaminginnovationgroup.atlassian.net/wiki/spaces/WPJ/pages/2225078360/Site"
                      rel="noreferrer"
                    >
                      Workflow
                    </a>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col d-flex">
          <div className="card flex-grow-1">
            <div className="card-body pt-0">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th scope="col">Environment</th>
                    <th scope="col">
                      {theme.name} Theme{' '}
                      {versions.latest.theme && (
                        <>
                          <br/>
                          <span className="text-muted small">(latest: {versions.latest.theme})</span>
                        </>
                      )}
                    </th>
                    <th scope="col">
                      Core-theme{' '}
                      {versions.latest.core && (
                        <>
                          <br/>
                          <span className="text-muted small">(latest: {versions.latest.core})</span>
                        </>
                      )}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {getBranches(site).map(({ name, branch, siteUrlTag }, index) => (
                    <tr key={index}>
                      <td>
                        <a target="_blank" href={getSiteUrl(siteUrlTag)} rel="noreferrer">
                          {name}
                        </a>
                      </td>
                      <td>
                        {versions.theme[branch]
                          ? (
                            <div className="d-flex align-items-center">
                              <a
                                href={tagUrl(`${theme.name}-theme`, `v${versions.theme[branch]}`)}
                                target="_blank"
                                rel="noreferrer"
                              >
                                {versions.theme[branch]}
                                
                              </a>
                              {versions.theme[branch] !== versions.latest.theme && (
                                <div className="d-flex" data-tooltip="Outdated">
                                  <i className="uil uil-exclamation-circle text-orange ml-1"></i>
                                </div>
                              )}
                            </div>
                          )
                          : 'N.A.'
                        }
                      </td>
                      <td>
                        {versions.core[branch]
                          ? (
                            <div className="d-flex align-items-center">
                              <a
                              href={tagUrl('gatsby-themes', `v${versions.core[branch]}`)}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {versions.core[branch]}
                              </a>
                              {versions.core[branch] !== versions.latest.core && (
                                <div className="d-flex" data-tooltip="Outdated">
                                  <i className="uil uil-exclamation-circle text-orange ml-1"></i>
                                </div>
                              )}
                            </div>
                          )
                          : 'N.A.'
                        }
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <ConfigurationEnv projectId={site.id} />
          <OpenMergeRequests projectId={site.id} />
          <ClosedMergeRequests projectId={site.id} />
          <BranchDifference site={site} />
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
}
